import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class FileUploadApi extends QuestionSimpleApi {
    public change({ responseActor, id: questionId }: QuestionContext, { value }: ResponseEventParams): void {
        responseActor.send({ type: 'CHANGE', value, questionId });
    }

    public query(questionActor: QuestionActor): AnswersRequest {
        const { files, id, responseActor } = questionActor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: (files || []).map(({ file: { id, name, path } }) => ({
                file: id,
                text: name,
                longtext: path,
            })),
            comment,
        };
    }

    public validate({ params: { fileAmount, required }, files = [] }: QuestionContext): boolean {
        if (!required) {
            return true;
        }

        const uploadedCount = files.reduce((acc, { file: { path } }) => ((acc += !!path ? 1 : 0), acc), 0);

        return files.length > 0 && uploadedCount <= fileAmount;
    }
}
